// extracted by mini-css-extract-plugin
module.exports = {"at-risk-trigger":"my-learning-unit-section_at-risk-trigger__UFfce","at-risk-trigger-button":"my-learning-unit-section_at-risk-trigger-button__VwGWq"};